import { ApiResponse } from "../admin";

export interface ITax {
  _id: string;
  name: string;
  type: string;
  rate: number;
  countryCode: string;
  country: string;
  inclusive?: boolean;
  description?: string;
  status: string;
  createdAt?: string;
}

export interface CreateTaxRequest {
  country: string;
  name: string;
  type: string;
  rate: number;
  description?: string;
  inclusive?: boolean;
}

export interface EditTaxRequest {
  id: string;
  data: Partial<CreateTaxRequest>;
}

export type TaxApiResponse = ApiResponse<ITax>;
export type TaxListApiResponse = ApiResponse<{ results: ITax[] }>;

export interface TaxTypeOption {
  value: string;
  label: string;
}

export const taxTypeOptions: TaxTypeOption[] = [
  { value: "VAT", label: "VAT" },
  { value: "GST", label: "GST" },
  { value: "Custom", label: "Custom" },
];
